import { gsap } from "gsap";
import $ from 'jquery';

function hero() {
	const $animatedContainer 	= $('.c-hero_title--animated');

	// Bail if no off canvas
	if( !$animatedContainer.length ) return;

	const $textItems 		= $('.c-hero_title-animate'),
				timeLine 			= gsap.timeline();

	$textItems.each(function(index, element) {
		let child = gsap.timeline();

		child.to(element, {alpha: 1, duration: 1});
		timeLine.add(child);
	});
}

export { hero };